/* DSL analytics handoff — forward DSL_AB & DSL_VITALS events naar PostHog/Mixpanel/eigen endpoint */
(function(){
  var CFG = window.DSL_CONFIG || {};
  function send(name, props){
    // GA4 / GTM dataLayer
    if (window.dataLayer && typeof window.dataLayer.push === "function") {
      window.dataLayer.push({event: "dsl_" + name, dsl: props || {}});
    }
    // PostHog (if loaded)
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture("dsl_" + name, props || {});
    }
    // Mixpanel
    if (window.mixpanel && typeof window.mixpanel.track === "function") {
      window.mixpanel.track("dsl_" + name, props || {});
    }
    // Custom endpoint
    if (CFG.analyticsEndpoint && navigator.sendBeacon) {
      try { navigator.sendBeacon(CFG.analyticsEndpoint, JSON.stringify({name: name, props: props, ts: Date.now(), pathname: location.pathname})); } catch(e){}
    }
  }
  window.addEventListener("dsl_ab_event", function(e){
    var d = e.detail || {};
    send(d.name || "ab", d.data || {});
  });
  // Hook DSL_VITALS data when emitted
  document.addEventListener("dsl:vitals", function(e){ send("vitals", e.detail || {}); });
  window.DSL_ANALYTICS = {send: send};
})();